import { EstateTaxFilingStatusKey } from '@/modules/estatetaxfiling/enums/EstateTaxFilingStatusKey';
import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';

export class EstateTaxFilingStatus extends Enum {
  key!: string;
  value!: string;
  color!: string;

  // TODO: Will be deprecated soon
  static NEW: EstateTaxFilingStatus = {
    key: 'new',
    value: 'New',
    color: '#8f8f8f'
  };

  static SUBMITTED: EstateTaxFilingStatus = {
    key: 'submitted',
    value: 'Waiting for final numbers',
    color: '#FF865B'
  };

  static CONFIRMED: EstateTaxFilingStatus = {
    key: 'confirmed',
    value: 'Confirmed',
    color: '#FF865B'
  };

  static REFUNDED: EstateTaxFilingStatus = {
    key: 'refunded',
    value: 'Refund received',
    color: '#60C49D'
  };

  static PAID: EstateTaxFilingStatus = {
    key: 'paid',
    value: 'Paid',
    color: '#60C49D'
  };

  // TODO: New statuses
  static NEW_FILE: EstateTaxFilingStatus = {
    key: EstateTaxFilingStatusKey.NEW_FILE,
    get value() {
      return Lang.t('estatetaxfiling.status-new-file');
    },
    color: '#9e19dd'
  };

  static IN_PROGRESS: EstateTaxFilingStatus = {
    key: EstateTaxFilingStatusKey.IN_PROGRESS,
    get value() {
      return Lang.t('estatetaxfiling.status-in-progress');
    },
    color: '#FFA500'
  };

  static HOLD_WAITING_FOR_PROBATE: EstateTaxFilingStatus = {
    key: EstateTaxFilingStatusKey.HOLD_WAITING_FOR_PROBATE,
    get value() {
      return Lang.t('estatetaxfiling.status-hold-waiting-for-probate');
    },
    color: '#f0c152'
  };

  static HOLD_WAITING_FOR_EIN: EstateTaxFilingStatus = {
    key: EstateTaxFilingStatusKey.HOLD_WAITING_FOR_EIN,
    get value() {
      return Lang.t('estatetaxfiling.status-hold-waiting-for-ein');
    },
    color: '#f0c152'
  };

  static HOLD_WAITING_FOR_IRS: EstateTaxFilingStatus = {
    key: EstateTaxFilingStatusKey.HOLD_WAITING_FOR_IRS,
    get value() {
      return Lang.t('estatetaxfiling.status-hold-waiting-for-irs');
    },
    color: '#f0c152'
  };

  static BELOW_FILING_THRESHOLD: EstateTaxFilingStatus = {
    key: EstateTaxFilingStatusKey.BELOW_FILING_THRESHOLD,
    get value() {
      return Lang.t('estatetaxfiling.status-below-filing-threshold');
    },
    color: '#c4c4c4'
  };

  static HOLD_PROBATE_REQUIRED: EstateTaxFilingStatus = {
    key: EstateTaxFilingStatusKey.HOLD_PROBATE_REQUIRED,
    get value() {
      return Lang.t('estatetaxfiling.status-hold-probate-required');
    },
    color: '#f0c152'
  };

  static HOLD_MISSING_PY_RETURNS: EstateTaxFilingStatus = {
    key: EstateTaxFilingStatusKey.HOLD_MISSING_PY_RETURNS,
    get value() {
      return Lang.t('estatetaxfiling.status-hold-missing-py-returns');
    },
    color: '#f0c152'
  };

  static HOLD_WAITING_FOR_T1_DOCS: EstateTaxFilingStatus = {
    key: EstateTaxFilingStatusKey.HOLD_WAITING_FOR_T1_DOCS,
    get value() {
      return Lang.t('estatetaxfiling.status-hold-waiting-for-t1-docs');
    },
    color: '#f0c152'
  };

  static HOLD_WAITING_FOR_T3_DOCS: EstateTaxFilingStatus = {
    key: EstateTaxFilingStatusKey.HOLD_WAITING_FOR_T3_DOCS,
    get value() {
      return Lang.t('estatetaxfiling.status-hold-waiting-for-t3-docs');
    },
    color: '#f0c152'
  };

  static CLOSED_CLIENT_SELF_FILING: EstateTaxFilingStatus = {
    key: EstateTaxFilingStatusKey.CLOSED_CLIENT_SELF_FILING,
    get value() {
      return Lang.t('estatetaxfiling.status-closed-client-self-filing');
    },
    color: '#d22d23'
  };

  static CLOSED_CHURNED_EARLY_CLOSURE: EstateTaxFilingStatus = {
    key: EstateTaxFilingStatusKey.CLOSED_CHURNED_EARLY_CLOSURE,
    get value() {
      return Lang.t('estatetaxfiling.status-closed-churned-early-closure');
    },
    color: '#d22d23'
  };

  static CLOSED_FILING_PBC: EstateTaxFilingStatus = {
    key: EstateTaxFilingStatusKey.CLOSED_FILING_PBC,
    get value() {
      return Lang.t('estatetaxfiling.status-closed-filing-pbc');
    },
    color: '#d22d23'
  };

  static CLOSED_COMPLETED: EstateTaxFilingStatus = {
    key: EstateTaxFilingStatusKey.CLOSED_COMPLETED,
    get value() {
      return Lang.t('estatetaxfiling.status-closed-completed');
    },
    color: '#d22d23'
  };

  static NOT_REQUIRED: EstateTaxFilingStatus = {
    key: EstateTaxFilingStatusKey.NOT_REQUIRED,
    get value() {
      return Lang.t('estatetaxfiling.status-not-required');
    },
    color: '#c4c4c4'
  };

  static PLANNING_CLIENT: EstateTaxFilingStatus = {
    key: EstateTaxFilingStatusKey.PLANNING_CLIENT,
    get value() {
      return Lang.t('estatetaxfiling.status-planning-client');
    },
    color: '#0ea5e9'
  };

  static getCanadaStatuses(): EstateTaxFilingStatus[] {
    return [
      EstateTaxFilingStatus.NEW_FILE,
      EstateTaxFilingStatus.IN_PROGRESS,
      EstateTaxFilingStatus.HOLD_PROBATE_REQUIRED,
      EstateTaxFilingStatus.HOLD_MISSING_PY_RETURNS,
      EstateTaxFilingStatus.HOLD_WAITING_FOR_T1_DOCS,
      EstateTaxFilingStatus.HOLD_WAITING_FOR_T3_DOCS,
      EstateTaxFilingStatus.PLANNING_CLIENT,
      EstateTaxFilingStatus.NOT_REQUIRED,
      EstateTaxFilingStatus.CLOSED_CLIENT_SELF_FILING,
      EstateTaxFilingStatus.CLOSED_CHURNED_EARLY_CLOSURE,
      EstateTaxFilingStatus.CLOSED_COMPLETED
    ];
  }

  static getUSStatuses(): EstateTaxFilingStatus[] {
    return [
      EstateTaxFilingStatus.NEW_FILE,
      EstateTaxFilingStatus.IN_PROGRESS,
      EstateTaxFilingStatus.HOLD_WAITING_FOR_PROBATE,
      EstateTaxFilingStatus.HOLD_WAITING_FOR_EIN,
      EstateTaxFilingStatus.HOLD_WAITING_FOR_IRS,
      EstateTaxFilingStatus.BELOW_FILING_THRESHOLD,
      EstateTaxFilingStatus.CLOSED_FILING_PBC,
      EstateTaxFilingStatus.CLOSED_CHURNED_EARLY_CLOSURE,
      EstateTaxFilingStatus.CLOSED_COMPLETED
    ];
  }
}
